<span (click)="tooltip.toggle()">
    <mat-icon #tooltip="matTooltip"
              [matTooltip]="text"
              [matTooltipPosition]="'after'">help</mat-icon>
</span>